import useComponentsStore from '@/stores/components';
import i18n from '@/i18n';

const emojiErrorMessage = 'Unacceptable characters in title and body.';

export default (error, defaultMessage) => {
  const responseData = error?.response?.data;

  const responseMessage = responseData?.errorMessage || responseData?.message;
  const trackingId = responseData?.trackingId;
  const { openAlertDialog } = useComponentsStore();
  const { t } = i18n.global;

  const validateMessages = responseData?.validate || [];
  const status = error?.response?.status;
  const errorMessage = error?.response?.data?.errorMessage;
  const errorCode = error?.response?.data?.errorCode;

  if (Array.isArray(responseData)) {
    responseData.forEach((value) => validateMessages.push(value));
  }

  switch (errorCode) {
    case 'ENTITY_NOT_FOUND':
      openAlertDialog({
        title: t('alert.notification'),
        content: 'Resource not found',
        trackingId,
      });
      return;
    case 'PERMISSION_DENIED':
      openAlertDialog({
        title: t('alert.notification'),
        content: 'Permission denied',
        trackingId,
      });
      return;
    case 'MULTIPART_EXCEPTION':
      openAlertDialog({
        title: t('alert.notification'),
        content: 'Upload failed: No file',
        trackingId,
      });
      return;
    default:
      break;
  }

  // emoji error message
  if (status === 500 && errorMessage === emojiErrorMessage) {
    openAlertDialog({
      title: t('alert.notification'),
      content: t('validation.emoji.subjectAndContent'),
      trackingId,
    });
    return;
  }

  // validate message
  if (validateMessages.length) {
    openAlertDialog({
      title: t('alert.notification'),
      content: `${validateMessages[0].field}: ${validateMessages[0].message}`,
      trackingId,
    });
    return;
  }

  // response message
  if (responseMessage) {
    openAlertDialog({
      title: t('alert.notification'),
      content: responseMessage,
      trackingId,
    });
    return;
  }

  if (defaultMessage) {
    openAlertDialog({
      title: t('alert.notification'),
      content: defaultMessage,
      trackingId,
    });
    return;
  }

  openAlertDialog({
    title: t('alert.notification'),
    content: t('globalError'),
    trackingId,
  });
};
